export const CUSTOMER_TAG_MAX_PAGE_SIZE = 50;
export const CUSTOMER_TAG_MAX_CHARACTER_LENGTH = 30;
export const CUSTOMER_NOTE_TEXT_LENGTH_LIMIT = 254;
export const CUSTOMER_NOTE_DEFAULT_PAGE_SIZE = 5;
export const CUSTOMER_NOTE_ALL_PAGE_SIZE = 99;
export const CUSTOMER_ORDER_LIMIT = 10;
export const CUSTOMER_DISPLAY_NAME_CHARACTER = 25;
